<template>
  <el-contianer>


        <el-container>


          <el-col :span="2" :offset="1">
            <el-button type="primary" @click="dialogFormVisible = true; isNotSecond = false">添加房间</el-button>
            <el-dialog title="添加房间" :visible.sync="dialogFormVisible" width="35%">



            <el-form ref="form" :model="AData" label-width="80px" >
              <el-form-item label="房间名称">
                <el-input v-model="AData.placeName"></el-input>
              </el-form-item>
              <el-form-item label="所属部门">
                <el-select style="width: 100%;" v-model="AData.ownerDeptId" placeholder="所属部门">
                  <el-option
                  v-for="i in DName"
                  :label="i.departmentName"
                  :key="i.departmentName"
                  :value="i.departmentId">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="面积">
                <el-input v-model="AData.area"></el-input>
              </el-form-item>

              <!-- <el-form-item label="上级区域">
                <el-select
                @focus="selectData"
                clearable
                style="width: 100%;" v-model="AData.placeMgr" placeholder="上级区域(不选择是一级区域,选择了则是二级区域)">
                    <el-option
                    v-for="i in PlaceName"
                    :label="i.placeName"
                    :key="i.placeName"
                    :value="i.placeId">
                    </el-option>
                </el-select>
              </el-form-item> -->


            </el-form>


              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogFormVisible = false;add()">确 定</el-button>
              </div>
            </el-dialog>
          </el-col>
          <el-col :span="2" :offset="1">
            <el-upload
              action="https://assert.hyhdit.com/apiYang/place/importExcelBigData"
              :on-success="handleSuccess"
              :on-progress="handleProgress"
              :on-error="handleError"
              :headers="token">
              <el-button  type="danger">点击上传文件批量导入房间信息</el-button>
            </el-upload>

          </el-col>
          <el-col :span="2" :offset="1">
            <el-button type="primary" @click="detele()">删除</el-button>
          </el-col>
        </el-container>



    <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="placeId"
        default-expand-all
        @select="select"
        @select-all="selectAll"
        @selection-change="selectionChange"
        ref="multipleTable"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">

        <el-table-column
              type="selection"
              width="55">
        </el-table-column>
        <el-table-column
          prop="placeName"
          label="房间名称"
          sortable
          width="180">
        </el-table-column>
        <el-table-column
          prop="unitName"
          label="所属单位"
          sortable
          width="180">
        </el-table-column>
        <el-table-column
          prop="departmentName"
          label="管理部门">
        </el-table-column>
        <el-table-column
          prop="area"
          label="房间面积/m²">
        </el-table-column>

        <el-table-column
          prop="createDate"
          label="创建时间">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="showDetail(scope.row)"
              type="text"
              size="small">
              查看
            </el-button>
            <el-button
              @click.native.prevent="downloadPlace(scope.row)"
              type="text"
              size="small">
              导出此区域
            </el-button>
          </template>
        </el-table-column>
    </el-table>
    <el-dialog
      title="区域信息"
      :visible.sync="detailDialogVisible"
      
      :close-on-click-modal="false"
      width="70%">
      <el-button type="primary" @click="dialogFormVisible = true; isNotSecond = true">添加房间</el-button>
      <el-button type="primary" @click="detele()">删除</el-button>
      <!-- <span>这是一段信息</span> -->
      <span slot="footer">
        <el-table
          :data="tableChildrenData"
          style="width: 100%;margin-bottom: 20px;"
          @selection-change="selectionChange"
          >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="placeName"
            label="房间名称"
            sortable
            width="180">
          </el-table-column>
          <el-table-column
            prop="unitName"
            label="所属单位"
            sortable
            width="180">
          </el-table-column>
          <el-table-column
            prop="departmentName"
            label="管理部门">
          </el-table-column>
          <el-table-column
            prop="area"
            label="房间面积/m²">
          </el-table-column>

          <el-table-column
            prop="createDate"
            label="创建时间">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="120">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="showChange(scope.row)"
                type="text"
                size="small">
                修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        
        <el-button type="primary" @click="detailDialogVisible = false">关 闭</el-button>
      </span>
      <el-pagination
        @size-change="childrenSizeChange"
        @current-change="childrenNoChange"
        :current-page="childrenPageNo"
        :page-sizes="[5, 10, 20, 30]"
        :page-size="childrenPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="childrenTotal">
      </el-pagination>
    </el-dialog>
    <el-dialog
      title="区域信息"
      :visible.sync="changeDialogVisible"
      :close-on-click-modal="false"
      width="70%"
      style="z-index: 3000;">
      <span slot="footer" >
        <div class="change_groups">
          <div class="change_item">
            <div class="change_item_title">修改区域名称：</div>
            <el-input v-model="changeData.placeName"></el-input>
          </div>
          <div class="change_item">
            <div class="change_item_title">修改区域面积：</div>
            <el-input v-model="changeData.area"></el-input>
          </div>
          <div class="change_item">
            <div class="change_item_title">修改部门</div>
            <el-select style="width: 100%;" v-model="ownerDeptId" placeholder="所属部门">
              <el-option
              v-for="i in DName"
              :label="i.departmentName"
              :key="i.departmentName"
              :value="i.departmentId">
              </el-option>
            </el-select>
          </div>
          <!-- <el-form-item label="上级区域">
            <el-select
            @focus="selectData"
            clearable
            style="width: 100%;" v-model="AData.placeMgr" placeholder="上级区域(不选择是一级区域,选择了则是二级区域)">
                <el-option
                v-for="i in PlaceName"
                :label="i.placeName"
                :key="i.placeName"
                :value="i.placeId">
                </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <div class="change_item">
            <div class="change_item_title">修改区域面积：</div>
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select
          </div> -->
        </div>
        <el-button type="primary" @click="changeDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="submitChangeData()">提 交</el-button>
      </span>
    </el-dialog>
    <el-pagination
      @size-change="sizeChange"
      @current-change="noChange"
      :current-page="pageNo"
      :page-sizes="[5, 10, 20, 30]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>


  </el-contianer>

</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import qs from "qs"
  export default {
     name: 'Unit',
     data () {

       const  tableData = [{
               placeId: '',
               placeMgr:'',
               unitId:'',
               unitName:'',
               area:'',
               createDate:'',
               del:'',
               departmentName:'',
               mgrName:'',
               children: [{
                 placeId: '',
                 placeMgr:'',
                 unitId:'',
                 unitName:'',
                 area:'',
                 createDate:'',
                 del:'',
                 departmentName:'',
                 mgrName:'',
                 children: [{
                   placeId: '',
                   placeMgr:'',
                   unitId:'',
                   unitName:'',
                   area:'',
                   createDate:'',
                   del:'',
                   departmentName:'',
                   mgrName:'',
                 }]
               }]
             }];


       return {
        //查看详情
        detailDialogVisible: false,
        pageNo: 1,
        pageSize: 10,
        total:0,
        // tableData: [],
        childrenPageNo: 1,
        childrenPageSize: 10,
        childrenTotal: 0,
        tableChildrenData: [],
        placeId: '',
        changeDialogVisible: false,
        changeData: {},
        
        isNotSecond: false,
        ownerDeptId: '',


         DName:[{
           departmentId:'',
           departmentName:'',
         }],
          AData:{
            placeName:'',
            ownerDeptId:'',
            unitId:'',
            area:'',
            placeMgr:''
          },
          multipleSelection:'',
          sortName: '',
          sortMgr: '',
          unitId: '',
          dialogFormVisible: false,
          filterText: '',
          PlaceName:[{
            placeName:'',
            placeId:'',
          }],
          token:{
            Authorization:Cookies.get("Authorization")
          },
           defaultProps: {
                    children: 'children',
                    label: 'label'
                  },
          tableData: JSON.parse(JSON.stringify(tableData)),
          }
       },
     created:function() {
       this.showData();
       this.showMgrPlace();
       this.showDepartmentData()
     },
     watch: {
           filterText(val) {
             this.$refs.tree.filter(val);
           }
         },

    methods: {
      //查看详情
      showDetail(rowData) {
        console.log(rowData)
        this.detailDialogVisible = true
        this.placeId = rowData.placeId
        this.showChildrenData()
      },
      //获取单位信息
      showData(){
        var authorization = Cookies.get("Authorization");
        var param={
          unitId: Cookies.get("UnitId"),
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        this.axios({
          method: 'GET',
          url: '/place/getTopPlaces',
			  params:param,
          // header:{
          //   'Authorization':authorization,
          //   'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
          // }
        }).then((res)=>{
          this.tableData = res.data.data;
          this.total = res.data.count
        })
      },
      //获取区域信息
      showChildrenData() {
        var param={
          placeId: this.placeId,
          pageNo: this.childrenPageNo,
          pageSize: this.childrenPageSize,
        }
        this.axios({
          method: 'GET',
          url: '/place/getPlaceChildren',
			    params:param,
        }).then((res)=>{
          this.tableChildrenData = res.data.data;
          this.childrenTotal = res.data.count
        })
      },

      //修改
      showChange(changeData) {
        console.log(changeData)
        this.changeData = changeData
        this.changeDialogVisible = true
      },
      submitChangeData() {
        let params = {
          placeId: this.changeData.placeId,
          placeName: this.changeData.placeName,
          area: this.changeData.area,
          ownerDeptId: this.ownerDeptId,
          placeMgr: this.changeData.placeMgr,
          unitId: Cookies.get('UnitId')
        }
        this.axios({
          method: 'POST',
          url: '/place/update',
          data: params,
        }).then((res)=>{
          if (res.data.code == 200) {
            this.$message.success('修改成功')
            this.changeDialogVisible = false
            this.showChildrenData()
          } else {
            this.$message.error(res.data.message)
          }
        })
      },

      //导出
      downloadPlace(scope) {
        let data = {
          unitId: this.unitId,
        }
        this.axios({
          method: 'POST',
          url: '/place/export',
          data: data,
        }).then((res)=>{
          if (res.data.code == 200) {
            console.log(res.data)
            window.location.href = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      //分页
      sizeChange(val) {
        this.pageSize = val
        this.pageNo = 1
        this.showData()
      },
      noChange(val) {
        this.pageNo = val
        this.showData()
      },
      //子分页
      childrenSizeChange(val) {
        this.childrenPageSize = val
        this.pageNo = 1
        this.showChildrenData()
      },
      childrenNoChange(val) {
        this.childrenPageNo = val
        this.showChildrenData()
      },

      // //删除
      // del() {

      // },


     showMgrPlace(){
       var authorization = Cookies.get("Authorization");
       this.axios({
           method: 'GET',
           url: '/place/firstPlace',
           params:{
             unitId:Cookies.get("UnitId")
           },
           header:{
            'Authorization':authorization,
           	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
           	}
         }).then((resp)=>{
             this.PlaceName = resp.data.data
         })
     },

     showDepartmentData(){
      var authorization = Cookies.get("Authorization");
      var params = {
        currentPage: 1,
        pageSize: 10,
      }
       this.axios({
           method: 'GET',
           url: '/public/getCanHandleDepartmentList',
           params:params,
           header:{
            'Authorization':authorization,
           	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
           	}
         }).then((resp)=>{
          this.DName = resp.data.data;
         })
     },






     setChildren(children, type) {
           // 编辑多个子层级
           children.map(j => {
             this.toggleSelection(j, type)
             if (j.children) {
               this.setChildren(j.children, type)
             }
           })
         },
         // 选中父节点时，子节点一起选中取消
         select(selection, row) {
           const hasSelect = selection.some(el => {
             return row.placeId === el.placeId
           })
           if (hasSelect) {
             if (row.children) {
               // 解决子组件没有被勾选到
               this.setChildren(row.children, true)
             }
           } else {
             if (row.children) {
               this.setChildren(row.children, false)
             }
           }
         },
         toggleSelection(row, select) {
           if (row) {
             this.$nextTick(() => {
               this.$refs.multipleTable &&
                 this.$refs.multipleTable.toggleRowSelection(row, select)
             })
           }
         },
         // 选择全部
         selectAll(selection) {
           // tabledata第一层只要有在selection里面就是全选
           const isSelect = selection.some(el => {
             const tableDataIds = this.tableData.map(j => j.placeId)
             return tableDataIds.includes(el.placeId)
           })
           // tableDate第一层只要有不在selection里面就是全不选
           const isCancel = !this.tableData.every(el => {
             const selectIds = selection.map(j => j.placeId)
             return selectIds.includes(el.placeId)
           })
           if (isSelect) {
             selection.map(el => {
               if (el.children) {
                 // 解决子组件没有被勾选到
                 this.setChildren(el.children, true)
               }
             })
           }
           if (isCancel) {
             this.tableData.map(el => {
               if (el.children) {
                 // 解决子组件没有被勾选到
                 this.setChildren(el.children, false)
               }
             })
           }
         },
         selectionChange(val) {
           this.multipleSelection = val;
         },


      detele(){
        var authorization = Cookies.get("Authorization");
        var deleteData = []
        for(let i of this.multipleSelection){
          deleteData.push(i.placeId)
        }
        this.axios({
            method: 'POST',
            url: '/place/del',
            params:{
              ids:deleteData
            },
            paramsSerializer:params =>{
              return qs.stringify(params,{indices:false})
            },
            header:{
             'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{
			if(resp.data.code==200){
			  this.open2(resp.data.message)
        
			}else{
			  this.open3(resp.data.message)
			}
      this.showChildrenData()
      this.showData() 
          })
      },


      open2(val) {
			this.$notify({
				title: val,
				message: val,
				type: 'success',
				duration: 3000
				});
            },
	 handleProgress() {
	 	this.$notify({
	 	  title: '上传中......',
	 	  message: '上传中，请稍等.....',
	 	  type: 'warning',
	 	  duration: 3000
	 	});
	 },
	 handleError(val){
		 this.$notify({
		   title: val,
		   message: val,
		   type: 'danger',
		   duration: 3000
		 });
	 },

      handleSuccess(res){
		if(res.code==200){
			this.open2(res.message)
			this.showData()
		}else{
			this.open3(res.message)
		}
      },

      open3(val) {
             this.$notify({
               title: '上传失败',
               message: val,
               type: 'error',
               duration: 3000
             });
           },
       selectData(){
         this.showMgrPlace()
       },
       filterNode(value, data) {
               if (!value) return true;
               return data.label.indexOf(value) !== -1;
             },

       


         select(val){
            var authorization = Cookies.get("Authorization");
            var paramsData = {
              currentPage: val || 1 || undefined,
              pageSize: 10,
              placeName:this.placeName || undefined,
              unitId:this.unitId || undefined,
            }
             this.axios({
                 method: 'GET',
                 url: '/place/show',
                 params:paramsData,
                 header:{
                  'Authorization':authorization,
                 	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                 	}
               }).then((resp)=>{
                  this.tableData=resp.data.data;
                  this.pageSize = resp.data.count;
               })
         },

          add(){
            var authorization = Cookies.get("Authorization");
		        console.log(this.AData.placeMgr)
		   // this.AData.placeMgr = 1
		        let placeMgr = 0
            if(this.isNotSecond) {
              placeMgr = this.placeId
            } 
		  //  if(this.AData.placeMgr == null || this.AData.placeMgr == undefined || this.AData.placeMgr == ""){
			//   placeMgr = 1
		  //  }else{
			//    placeMgr = this.AData.placeMgr
		  //  }
            this.axios({
               method: 'POST',
               url: '/place/add',
               data: {
                 placeName:this.AData.placeName,
                 ownerDeptId:this.AData.ownerDeptId,
                 unitId:Cookies.get("UnitId"),
                 placeMgr:placeMgr,
                 area:parseInt(this.AData.area)
               },  //这里json对象会转换成json格式字符串发送
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
                  if(resp.data.code==200){
                  this.open2(resp.data.message)
					        this.showData()
                  this.showChildrenData()
                  }else{
                    this.open3(resp.data.message)
                  }
               })

         },
         handleEdit(index, row) {
              var authorization = Cookies.get("Authorization");
              this.axios({
                  method: 'POST',
                  url: '/place/update',
                  data:{
                   placeId:this.EplaceId,
                   placeName:this.EplaceName,
                   ownerDeptId:this.EownerDeptId,
                   unitId:this.EunitId
                  },
                  header:{
                   'Authorization':authorization,
                  	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                  	}
                })
              },

     }
   }
</script>

<style scoped lang="less">
.change_groups {
  display: flex;
  flex-direction: column;

  .change_item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    .change_item_title {
      width: 180px;
      line-height: 40px;
      margin-right: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Munber/Place.vue